import * as React from 'react';

import classify from 'src/utils/classify';

import Arrow from './arrow.svg';

import css from './conversation-builder.css';


type Point = {
  x: number;
  y: number;
};

const arcRadius = 5;
const arrowWidth = 12;
const arrowHeight = 10;
const halfArrowWidth = arrowWidth / 2;

// NOTE (kyle): could memo
export default function ArcedPath({
  inPoint,
  outPoint,
  turnPoint,
  isInvalid,
}: {
  inPoint: Point;
  outPoint: Point;
  turnPoint: number;
  isInvalid: unknown;
}) {
  const svgLeft = Math.min(inPoint.x, outPoint.x);
  const svgTop = Math.min(inPoint.y, outPoint.y);
  const svgLeftMax = Math.max(inPoint.x, outPoint.x);
  const svgTopMax = Math.max(inPoint.y, outPoint.y);

  const width = svgLeftMax - svgLeft + 2;
  const height = svgTopMax - svgTop;

  const xStart = inPoint.x - svgLeft + 1;
  const yStart = inPoint.y - svgTop;
  const xStop = outPoint.x - svgLeft + 1;
  const yStop = outPoint.y - svgTop;

  const yCenter = turnPoint - svgTop;
  //const yCenter = yStart - height / 2;
  const pathYStart = yStart - 3;
  const xDirection = Math.sign(xStop - xStart);
  const arcDirection = xDirection === 1 ? 1 : 0;

  const viewBoxYOrigin = yCenter - arcRadius < 0 ? yCenter - arcRadius : 0;

  return (
    <div
      className={classify(css.edge, isInvalid && css.edgeError)}
      style={{
        left: svgLeft - 1 + 'px',
        top: svgTop + 'px',
      }}
    >
      <svg
        className={css.path}
        viewBox={`0 ${viewBoxYOrigin} ${width} ${height}`}
        width={width}
        height={height - viewBoxYOrigin}
      >
        {xStart !== xStop ? (
          <path
            d={`M ${xStart},${pathYStart} L ${xStart},${
              yCenter + arcRadius
            } A ${arcRadius} ${arcRadius} 0 0 ${arcDirection} ${
              xStart + xDirection * arcRadius
            },${yCenter} L ${
              xStop - xDirection * arcRadius
            } ${yCenter} A ${arcRadius} ${arcRadius} 0 0 ${
              (arcDirection + 1) % 2
            } ${xStop} ${yCenter - arcRadius} L ${xStop},${-1 * height}`}
          />
        ) : (
          <path d={`M ${xStart} ${pathYStart} L ${xStop} ${yStop}`} />
        )}
      </svg>
      <Arrow
        className={css.arrow}
        style={{
          left: xStart - halfArrowWidth,
          top: yStart - arrowHeight - 1,
        }}
      />
    </div>
  );
}
